module.exports = __webpack_public_path__ + "img/8-1.a7170bfc.png";